/**
 * This is where all redux functions are
 * @module reduxStore
 */

const Redux = require('redux/dist/redux.js');
const SharedModels = require('../../../../shared/sharedModels');
const EditorReducer = require('./editorReducer.js').EditorReducer;
const EditorFunctions = require('./editorReducer.js').FunctionList;
const EvidenceCardReducer = require('./evidenceCardReducer.js').EvidenceCardReducer;
const EvidenceCardFunctions = require('./evidenceCardReducer.js').FunctionList;
const GreySpaceCardReducer = require('./greySpaceCardReducer.jsx.js').GreySpaceCardReducer;
const GreySpaceCardFunctions = require('./greySpaceCardReducer.jsx.js').FunctionList;
const StimulusCardReducer = require('./stimulusCardReducer.jsx.js').StimulusCardReducer;
const StimulusCardFunctions = require('./stimulusCardReducer.jsx.js').FunctionList;
const CardReducer = require('./cardReducer.js').CardReducer;
const CardFunctions = require('./cardReducer.js').FunctionList;
const DeckReducer = require('./deckReducer.js').Reducer;
const DeckFunctions = require('./deckReducer.js').FunctionList;
const PortfolioReducer = require('./portfolioReducer.js').Reducer;
const PortfolioFunctions = require('./portfolioReducer.js').FunctionList;
const WorkspaceTagReducer = require('./workspaceTagReducer').Reducer;
const WorkspaceTagFunctions = require('./workspaceTagReducer').FunctionList;
const UserReducer = require('./userReducer').Reducer;
const UserFunctions = require('./userReducer').FunctionList;
const MessageReducer = require('./messageReducer').Reducer;
const MessageFunctions = require('./messageReducer').FunctionList;
const RecentCardManager = require('../recentCardManager.jsx.js').RecentCardManager;
const LocalStorage = require('../localStorage.js');


const initialState = {
   EditorReducer:{
      isEditing: false,
      allTopics: [],
      checkForValidationErrors: false,
      topicFilterArray: [],
      idDeckFilterArray: [],
      cardTypeFilterArray: [],
      searchString: '',
      showLinkBtn: false,
   },
   EvidenceCardReducer:{
      curCard: new SharedModels.EvidenceCard({}),
      recentCards: [],
      cardList: [],
      validationErrors: {},
      unapprovedList: [],
      revisingCard: {},
   },
   GreySpaceCardReducer:{
      curCard: new SharedModels.GreySpaceCard({}),
      cardList: [],
      creationEvidence: [],
   },
   StimulusCardReducer:{
      curCard: new SharedModels.StimulusCard({}),
      cardList: [],
   },
   CardReducer:{
      cardList: [],
      conjectureGameList: [],
      toReview: [],
   },
   DeckReducer:{
      deckList: [],
   },
   PortfolioReducer:{
      portfolioList: {owned: [], shared: [], sponsored: []},
      curPortfolio: new SharedModels.Portfolio({}),
      isLoaded: false,
      synthesisTemplates: [],
   },
   WorkspaceTagReducer:{
      tagList: [],
      filterList: [],
   },
   UserReducer:{
      curUser: new SharedModels.User({}),
      targetUser: new SharedModels.User({}),
      isCurrentUserFollowing: false,
   },
   MessageReducer:{
      correspondent: new SharedModels.User({}),
      messages: [],
      overview: [],
   },
};

let savedRecentEvidenceCards = LocalStorage.getItem('recentEvidenceCards');
if(savedRecentEvidenceCards){
   try{
      initialState.EvidenceCardReducer.recentCards = JSON.parse(savedRecentEvidenceCards);
      RecentCardManager.loadData({evidenceCards: initialState.EvidenceCardReducer.recentCards});
   }
   catch(e){
      LocalStorage.setItem('recentEvidenceCards', '');
   }
}

let savedTopicFilterArray = LocalStorage.getItem('topicFilterArray');
let savedDeckFilterArray = LocalStorage.getItem('deckFilterArray');

if(savedTopicFilterArray){
   try{
      initialState.EditorReducer.topicFilterArray = JSON.parse(savedTopicFilterArray);
   }
   catch(e){
      LocalStorage.setItem('topicFilterArray', '');
   }
}
// the <=2 is because we can have a string '[]'
if((!savedTopicFilterArray || savedTopicFilterArray.length <= 2) &&savedDeckFilterArray){
   try{
      initialState.EditorReducer.idDeckFilterArray = JSON.parse(savedDeckFilterArray);
   }
   catch(e){
      LocalStorage.setItem('deckFilterArray', '');
   }
}

if(typeof(initialState.EditorReducer.topicFilterArray) !== 'object'
      || typeof(initialState.EditorReducer.idDeckFilterArray) !== 'object'){
   console.log('saved filter array is not an array. Resetting to blank');
   initialState.EditorReducer.idDeckFilterArray = null;
   initialState.EditorReducer.topicFilterArray = null;
   LocalStorage.setItem('topicFilterArray', '');
   LocalStorage.setItem('deckFilterArray', '');
}

const addCardToRecentList = store => next => action => {
   let idCardPrevious = store.getState().EvidenceCardReducer.curCard.idEvidenceCard;
   let result = next(action);
   let idCardNew = store.getState().EvidenceCardReducer.curCard.idEvidenceCard;
   if(parseInt(idCardPrevious) !== parseInt(idCardNew) && idCardNew > 0){
      RecentCardManager.pushEvidenceCard(store.getState().EvidenceCardReducer.curCard);
      store.dispatch(exports.EvidenceCardFunctions.setRecentCards(RecentCardManager.evidenceCards));
      LocalStorage.setItem('recentEvidenceCards', RecentCardManager.evidenceCards);
   }
   return result;
};

const saveCurrentFilters = store => next => action => {
   let result = next(action);
   LocalStorage.setItem('topicFilterArray', JSON.stringify(store.getState().EditorReducer.topicFilterArray));
   LocalStorage.setItem('deckFilterArray', JSON.stringify(store.getState().EditorReducer.idDeckFilterArray));
   return result;
};

const combinedReducer = Redux.combineReducers({
   EditorReducer,
   EvidenceCardReducer,
   GreySpaceCardReducer,
   StimulusCardReducer,
   CardReducer,
   DeckReducer,
   PortfolioReducer,
   WorkspaceTagReducer,
   UserReducer,
   MessageReducer,
});

const store = Redux.createStore(combinedReducer,initialState, Redux.applyMiddleware(addCardToRecentList, saveCurrentFilters));


exports.EditorFunctions = EditorFunctions;
exports.EvidenceCardFunctions = EvidenceCardFunctions;
exports.GreySpaceCardFunctions = GreySpaceCardFunctions;
exports.StimulusCardFunctions = StimulusCardFunctions;
exports.DeckFunctions = DeckFunctions;
exports.PortfolioFunctions = PortfolioFunctions;
exports.CardFunctions = CardFunctions;
exports.WorkspaceTagFunctions = WorkspaceTagFunctions;
exports.UserFunctions = UserFunctions;
exports.MessageFunctions = MessageFunctions;

exports.store = store;


exports.getEvidenceCardByID = (id) => {
   for(let card of store.getState()['CardReducer'].cardList){
      if(parseInt(id) === card.id){
         return card;
      }
   }
   return null;
};

exports.getGreySpaceCardByID = (id) => {
   for(let card of store.getState()['CardReducer'].conjectureGameList){
      if(parseInt(id) === card.id){
         return card;
      }
   }
   for(let card of store.getState()['CardReducer'].cardList){
      if(parseInt(id) === card.id){
         return card;
      }
   }
   for(let card of store.getState()['GreySpaceCardReducer'].cardList){
      if(parseInt(id) === card.id){
         return card;
      }
   }
   return null;
}
;
exports.isEvidenceCardSet = () => {
   let curID = store.getState().EvidenceCardReducer.curCard.idEvidenceCard;
   return (curID && curID !== 0);
};

exports.isGreySpaceCardSet = () => {
   let curCard = store.getState().GreySpaceCardReducer.curCard;
   return curCard.hasRequiredFields();
};

exports.isStimulusCardSet = () => {
   let curID = store.getState().StimulusCardReducer.curCard.idStimulusCard;
   return (curID && curID !== 0);
};

exports.createStore = () => {
   return Redux.createStore(combinedReducer,initialState, Redux.applyMiddleware(addCardToRecentList));
};

exports.processCardData = (data) =>{
   let cards = SharedModels.formatListViewData(data);
   store.dispatch(exports.CardFunctions.setCardList(cards));
};

exports.appendCardData = (data) =>{
   let cards = SharedModels.formatListViewData(data);
   let curCards = store.getState().CardReducer.cardList;

   store.dispatch(exports.CardFunctions.setCardList(curCards.concat(cards)));
};